import { UserIcon } from "lucide-react";
import { useState, useEffect } from "react";
import React from "react";
import userIcon from "../../icons/userIcon.svg";
import PhoneInput from "../ui/PhoneInput";
import { baseUrl } from "../../Environments/environment.js";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Input from "../ui/Input";
import { toast, ToastContainer, Bounce } from "react-toastify";
import axios from "axios";
import { ThreeDot } from "react-loading-indicators";
import "react-toastify/dist/ReactToastify.css";
import FirstForm from "./FirstForm";
import SecondForm from "./SecondForm";
import ThirdForm from "./ThirdForm";
import countries from "../../data/countries.js";
const Registration = () => {
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("United States +1");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkIn, setCheckIn] = useState(
    new Date().toISOString().split("T")[0],
  );
  const cCode = countryCode.split(" ")[countryCode.split(" ").length - 1];
  const [checkInTime, setCheckInTime] = useState();
  const [checkOut, setCheckOut] = useState(
    new Date(+new Date() + 86400000).toISOString().split("T")[0],
  );
  const [checkOutTime, setCheckOutTime] = useState();
  const [otp, setOtp] = useState("");
  const [propertySettings, setPropertySettings] = useState({});
  const [error, setError] = useState({});

  const { propertyId } = useParams();
  const [searchParams] = useSearchParams();
  const roomno = searchParams.get("roomno");
  const navigate = useNavigate();
  useEffect(() => {
    const scannedQrCode = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}/qrCodeScan/${propertyId}`,
          {
            roomNumber: roomno,
          },
        );
      } catch (error) {
        console.error("Error fetching property settings:", error);
      }
    };
    scannedQrCode();
  }, []);
  useEffect(() => {
    const getPropertySettings = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/setting/guest/${propertyId}`,
        );
        setPropertySettings(response.data.result.setting);
        console.log(response.data.result.setting);
        setCheckInTime(response.data.result.setting.standardCheckinTime);
        setCheckOutTime(response.data.result.setting.standardCheckoutTime);
      } catch (error) {
        console.error("Error fetching property settings:", error);
      }
    };
    getPropertySettings();
  }, [propertyId]);
  const onCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };
  const onPhoneNumberChange = (e) => {
    console.log(e.target.value);
    setPhoneNumber(e.target.value);
  };
  const onFirstNameChange = (e) => {
    console.log(e.target.value);
    setFirstName(e.target.value);
  };
  const onLastNameChange = (e) => {
    setLastName(e.target.value);
  };
  const onCheckInChange = (e) => {
    setCheckIn(e.target.value);
  };
  const onCheckInTimeChange = (e) => {
    setCheckInTime(e.target.value);
  };
  const onCheckOutChange = (e) => {
    setCheckOut(e.target.value);
  };
  const onCheckOutTimeChange = (e) => {
    setCheckOutTime(e.target.value);
  };
  const onOtpChange = (e) => {
    console.log(e.target.value);
    setOtp(e.target.value);
  };

  const handleNext = async (e) => {
    try {
      e.preventDefault();
      switch (step) {
        case 1:
          await onPhoneCheck(e);
          setStep(2);
          return;
        case 2:
          if (cCode === "+86") {
            await registerGuest(e);
            return;
          }
          await sendOtp(e);
          return;
        case 3:
          await registerGuest(e);
          return;
      }
    } catch (e) {
      console.log(e);
    }
  };
  const sendOtp = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const payload = {
        countryCode: cCode,
        phoneNumber: phoneNumber,
        firstName: firstName,
        lastName: lastName,
        checkIn: `${checkIn}T${checkInTime}`,
        checkOut: `${checkOut}T${checkOutTime}`,
      };
      const response = await axios.post(
        `${baseUrl}/guest/sendOtp/${propertyId}`,
        payload,
      );
      console.log(payload);
      setLoading(false);
      if (response.data.result.guestSessionId) {
        navigate(`/${response.data.result.guestSessionId}/houseKeeping`);
        return;
      }
      setStep(3);
    } catch (e) {
      setLoading(false);
      Object.keys(e.response.data.error).map((key) => {
        toast.error(`${e.response.data.error[key][0]}`);
      });
    }
  };
  console.log(roomno);
  const registerGuest = async (e) => {
    try {
      setLoading(true);
      const payload = {
        countryCode: cCode,
        phoneNumber: phoneNumber,
        firstName: firstName,
        lastName: lastName,
        checkIn: `${checkIn}T${checkInTime}`,
        checkOut: `${checkOut}T${checkOutTime}`,
        otp: otp,
        roomNumber: roomno,
      };
      console.log(payload);
      const guest = await axios.post(
        `${baseUrl}/guest/guestRegistration/${propertyId}`,
        {
          countryCode: cCode,
          phoneNumber: phoneNumber,
          firstName: firstName,
          lastName: lastName,
          checkIn: `${checkIn}T${checkInTime}`,
          checkOut: `${checkOut}T${checkOutTime}`,
          otp: otp,
          roomNumber: roomno,
        },
      );
      console.log(guest);
      setLoading(false);
      navigate(`/${guest.data.result.guest.guestSessionId}/houseKeeping`);
    } catch (e) {
      setLoading(false);
      Object.keys(e.response.data.error).map((key) => {
        toast.error(`${e.response.data.error[key][0]}`);
      });
    }
  };
  const onPhoneCheck = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      console.log("Phone Number :-", phoneNumber);
      console.log("Country Code :-", cCode);

      const guest = await axios.post(
        `${baseUrl}/guest/getGuestByPhoneNumber/${propertyId}`,
        {
          phoneNumber: phoneNumber,
          countryCode: cCode,
        },
      );
      setLoading(false);
      console.log(guest);
      if (guest.data.result.guestSession) {
        navigate(`/${guest.data.result.guestSession._id}/houseKeeping`);
        return;
      } else {
        throw new Error("Guest not found");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (error.response.data.statusCode === 404) {
        setStep(3);
        return;
      }
      console.log(JSON.parse(error.message));
    }
  };
  return (
    <>
      <form onSubmit={(e) => handleNext(e)}>
        <div className=" mx-5 mt-5 text-neutral-800">
          <div className="flex justify-between items-center font-poppins h-full">
            <div className="bg-neutral-200 px-3 p-1 rounded-lg text-sm font-poppins">
              Our Services
            </div>
            <div>
              <img
                src={userIcon}
                alt="userIcon"
                className="object-contain w-6 h-6 "
              />
            </div>
          </div>
          <div className="rounded-xl p-5 bg-neutral-100 my-5">
            <div className="flex flex-col gap-2">
              <RegistrationFormController
                step={step}
                FirstForm={
                  <FirstForm
                    countryCode={countryCode}
                    phoneNumber={phoneNumber}
                    onPhoneNumberChange={onPhoneNumberChange}
                    onCountryCodeChange={onCountryCodeChange}
                    handleNext={handleNext}
                    step={step}
                  />
                }
                SecondForm={
                  <SecondForm
                    firstName={firstName}
                    lastName={lastName}
                    countryCode={countryCode}
                    phoneNumber={phoneNumber}
                    checkIn={checkIn}
                    checkInTime={checkInTime}
                    checkOut={checkOut}
                    checkOutTime={checkOutTime}
                    onFirstNameChange={onFirstNameChange}
                    onLastNameChange={onLastNameChange}
                    onPhoneNumberChange={onPhoneNumberChange}
                    onCountryCodeChange={onCountryCodeChange}
                    onCheckInChange={onCheckInChange}
                    onCheckInTimeChange={onCheckInTimeChange}
                    onCheckOutChange={onCheckOutChange}
                    onCheckOutTimeChange={onCheckOutTimeChange}
                    handleNext={handleNext}
                    step={step}
                  />
                }
                ThirdForm={
                  <ThirdForm
                    otp={otp}
                    onOtpChange={onOtpChange}
                    handleNext={handleNext}
                    step={step}
                  />
                }
              />
            </div>
            <div className="flex justify-between items-center w-full mt-4 ">
              <button
                className="w-full px-3 py-1 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                type="submit"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </form>
      {/* loading */}
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-20 flex justify-center items-center">
          <ThreeDot
            variant="brick-stack"
            color="#4f46e5"
            size="medium"
            text=""
            textColor=""
          />
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </>
  );
};
const RegistrationFormController = ({
  step,
  FirstForm,
  SecondForm,
  ThirdForm,
}) => {
  switch (step) {
    case 1:
      return FirstForm;
    case 2:
      return SecondForm;
    case 3:
      return ThirdForm;
  }
};
export default Registration;
